import * as React from "react";
import { Link } from "react-router-dom";
import { TopMerchants } from "@njoy/controller";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import * as ROUTES from "../../../constants/routes";
import NoticeBox from "../../../components/noticeBox/NoticeBox";
import TopMerchantSkeleton from "./TopMerchantSkeleton";


const Slider = require("react-slick").default;
const options = {
  dots: false,
  arrows: false,
  infinite: true,
  autoplay: true,
  draggable: true,
  swipe: true,
  touchMove: true,
  variableWidth: true,
  centerMode: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500,
  responsive: [
    {
      breakpoint: 370,
      settings: {
        variableWidth: false,
      },
    },
  ],
};

export const TopMerchant: React.FC = () => {
  return (
    <TopMerchants variables={{ offset: 0, limit: 10 }}>
      {({ merchants, loading }) => {
        if (loading) {
          return (
            <div className="px-[1rem] pb-5 mt-3 gap-3 flex">
              <TopMerchantSkeleton />
              <TopMerchantSkeleton />
            </div>
          );
        }

        if (!merchants.length) {
          return (
            <NoticeBox forceFullWidth={true} message="There are no offers trending at the moment." />
          );
        }

        return (
          <Slider {...options} className="h-[30%] pb-5 mt-3">
            {merchants.map((m) => (
              <div key={m.id}>
                <div className="flex flex-col px-[6px]">
                  <Link to={`${ROUTES.VIEW_MERCHANT}/${m.id}`}>
                    <div className="w-[259px] max-[370px]:!px-2 !max-[350px]:!px-4 max-[340px]:!px-6 max-[320px]:!px-6">
                      <img
                        className="h-[142px] object-cover w-full rounded-[10px]"
                        src={m.admin?.merchantProfile?.bannerUrl ?? ""}
                        alt="merchant banner"
                      />
                    </div>
                    <div className="w-[250px] justify-center items-center p-2 flex gap-2">
                      <div className="rounded-full ">
                        <img
                          className="rounded-full w-[31px] h-[31px] object-cover"
                          src={m.admin?.merchantProfile?.logoUrl ?? ""}
                          alt="merchant_icon"
                        />
                      </div>
                      <div className="flex flex-col text-white w-[80%]">
                        <p className="text-medium truncate max-[400px]:text-sm">{m.admin?.merchantProfile?.companyName ?? ""}</p>
                        <p className="text-[#A6A6A6] text-xs truncate">
                          {m.admin?.merchantProfile?.companyLocation ?? ""}
                        </p>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            ))}
          </Slider>
        );
      }}
    </TopMerchants>
  );
};